import { DataCache, Predicate, injectDataCache, predicate } from '@aesop-fables/scrinium';
import { Observable } from 'rxjs';
import { pricebookStorageKey, PricebookCompartments } from '../data/pricebook';
import { Predicates } from './Types';

@predicate(Predicates.OrganizationSelected)
export class OrgAvailablePricebooksInitialized implements Predicate {
  constructor(
    @injectDataCache(pricebookStorageKey)
    private readonly pricebookDataCache: DataCache<PricebookCompartments>,
  ) {}

  createObservable(): Observable<boolean> {
    return this.pricebookDataCache.findCompartment('orgAvailablePricebooks').initialized$;
  }
}
